module.exports = __webpack_public_path__ + "img/corethings_dark_theme_1200_thick_tailwind.d66b4b33.png";